import { useEffect, useState } from "react";
import { EBlogResponse, IBlogGetPage } from "../../models/blog";
import BlogService from "../../services/api/blog.service";
import {
  BlogCard,
  BlogCardDesc,
  BlogCardTitle,
  BlogContent,
  BlogDesc,
  BlogGrid,
  BlogHeader,
  BlogMeta,
  BlogPageWrapper,
  BlogThumb,
  BlogTitle,
} from "../../style/blog.style";
import moment from "moment";
import { envConfig } from "../../config/env.config";
import { Box } from "@mui/material";
import { Helmet } from "react-helmet-async";
import SeoService from "../../services/api/seo.service";
import { ECommonPageSeo } from "../../models/seo";
import FAQ from "../../components/FAQ";
import { useTranslation } from "react-i18next";
import FaqService from "../../services/api/faq.service";
import { FaqItem } from "../../models/faq";

export default function FaqPage() {
  const [blogs, setBlogs] = useState<EBlogResponse[]>([]);
  const [currentLocale, setCurrentLocale] = useState<string>("vi");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(12);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const { t, i18n } = useTranslation();

  const [faqs, setFaqs] = useState<FaqItem[]>();
  const [commonPageSeo, setCommonPageSeo] = useState<ECommonPageSeo>();

  const getDataContent = async (langParam?: string) => {};

  // useEffect(() => {
  //   getDataContent(i18n.language);
  // }, [i18n.language]);

  useEffect(() => {
    const init = async () => {
      const res = await FaqService.getAll(i18n.language);

      if (res.success) {
        res.data.map((p) => {
          p.answer = p.answer.replace(/&nbsp;/g, " ");
        });

        setFaqs(res.data);
      }

      const lang = i18n.language?.toUpperCase();

      const resSeo = await SeoService.getCommonPageSeo("Faq", lang);

      if (resSeo.success) {
        res.data && setCommonPageSeo(resSeo.data);
      }
    };

    init();
  }, [i18n.language]);

  return (
    <>
      <Helmet>
        {/* ===== BASIC SEO ===== */}
        <title>
          {commonPageSeo?.page?.title || "Dịch tài liệu online | MikoTech"}
        </title>

        <meta
          name="description"
          content={
            commonPageSeo?.seo?.description ||
            "Dịch tài liệu online nhanh, chính xác, bảo mật. Hỗ trợ PDF, Word, Excel, PPT, hình ảnh."
          }
        />

        <meta
          name="keywords"
          content={
            commonPageSeo?.seo?.keywords ||
            "dịch tài liệu, dịch file pdf, dịch tiếng anh"
          }
        />

        <link rel="icon" href="/logo/logodocme.svg" />
        <meta name="author" content={commonPageSeo?.seo?.author} />
        {/* <meta name="robots" content="index, follow" /> */}
        <meta
          name="robots"
          content={
            commonPageSeo?.seo?.noIndex ? "noindex, nofollow" : "index, follow"
          }
        />
        {/* ===== CANONICAL ===== */}
        <link
          rel="canonical"
          href={
            commonPageSeo?.seo?.canonical
              ? commonPageSeo?.seo?.canonical
              : "https://docme.vn" + commonPageSeo?.page.url
          }
        />

        {/* ===== OPEN GRAPH ===== */}
        <meta property="og:type" content={commonPageSeo?.seo?.og_type} />
        <meta
          property="og:site_name"
          content={commonPageSeo?.seo?.og_site_name}
        />
        <meta property="og:title" content={commonPageSeo?.seo?.og_title} />
        <meta
          property="og:description"
          content={commonPageSeo?.seo?.og_description}
        />
        <meta
          property="og:url"
          content={commonPageSeo?.seo?.og_url || "https://docme.vn/"}
        />
        <meta property="og:image" content={commonPageSeo?.seo?.og_image_alt} />
        <meta
          property="og:image:width"
          content={commonPageSeo?.seo?.og_image_width}
        />
        <meta
          property="og:image:height"
          content={commonPageSeo?.seo?.og_image_height}
        />
        <meta property="og:locale" content={commonPageSeo?.seo?.og_locale} />

        <meta name="twitter:card" content={commonPageSeo?.seo?.twitter_card} />
        <meta
          name="twitter:title"
          content={commonPageSeo?.seo?.twitter_title}
        />
        <meta
          name="twitter:description"
          content={commonPageSeo?.seo?.twitter_description}
        />
        <meta
          name="twitter:image"
          content={commonPageSeo?.seo?.twitter_image}
        />

        {/* ===== CONTACT / BUSINESS INFO ===== */}
        {commonPageSeo?.seo?.schema && (
          <div
            dangerouslySetInnerHTML={{ __html: commonPageSeo?.seo?.schema }}
          />
        )}
      </Helmet>
      <BlogPageWrapper>
        <div style={{ paddingTop: "40px" }}>{faqs && <FAQ faqs={faqs} />}</div>
      </BlogPageWrapper>
    </>
  );
}
